import { render, staticRenderFns } from "./storeInitGoodsCat.vue?vue&type=template&id=442ad81c&"
import script from "./storeInitGoodsCat.vue?vue&type=script&lang=js&"
export * from "./storeInitGoodsCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports